import {Component, Input} from '@angular/core';
import {PhoneInfoInterface} from '../../core/model/phone-info.interface';

@Component({
  selector: 'app-button-image',
  templateUrl: './button-image.component.html',
  styleUrls: ['./button-image.component.scss']
})
export class ButtonImageComponent {

  @Input() button: PhoneInfoInterface;
  @Input() showLabel = true;

  hideSpinner = false;

  constructor() {
  }

  imageLoaded() {
    this.hideSpinner = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/button-image/button-image.component.ts